import { UrlConstants } from "../url.constants";
export class ApiBusinessLicenceConstants {
    static URL = UrlConstants.API_V2 + "BusinessLicence";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalBusinessLicenceApplication";
    static FUNCTION_CREATE_RESUBMITTED_APPLICATION = "CreateResubmittedPortalBusinessLicenceApplication";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetBusinessLicenceApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetBusinessLicenceProperties";
    static FUNCTION_GET_MY_AFLA_BUSINESS_LICENCE_APPLICATIONS = "GetMyAFLAPortalBusinessLicenceApplications";
    static FUNCTION_GET_ALL_AFLA_PORTAL_BUSINESS_LICENCE_APPLICATIONS = "GetAllAFLAPortalBusinessLicenceApplications";
    static FUNCTION_GET_APPLICATION_TYPE = "GetBlApplicationTypes";
}
